import { Component, Shark } from "shark-mvc";
import { Modal } from "bootstrap";

import ImageContent from "../../models/ImageContent";
import PlaceContent from "../../models/PlaceContent";
import TextContent from "../../models/TextContent";

import templateContent from "./new-content-type-modal.html";

import imageContentView from "../../views/imageContent/imageContentView";
import placeContentView from "../../views/placeContent/placeContentView";
import textContentView from "../../views/textContent/textContentView";

class NewContentTypeModalComponent extends Component {
	constructor () {
		super("newContentTypeModalComponent");

		this.addTemplate("", templateContent);
	}

	addContentBtn_clickHandler () {
		this.open();
	}

	afterLoad () {
		this.modal = new Modal(document.querySelector("#newContentTypeModal"));
	}

	close () {
		this.modal.hide();
	}

	init () {

	}

	open () {
		this.modal.show();
	}

	newContentTypeBtn_clickHandler (event, data) {
		const newContentType = data.contentType;

		if (newContentType && newContentType.trim() !== "") {
			console.log(newContentType);
			let destView;
			let currContent;

			switch (newContentType) {
				case "image":
					destView = imageContentView;
					currContent = new ImageContent({
						createdByGuid: Shark.$store.currUser.guid,
					});
					break;
				case "place":
					destView = placeContentView;
					currContent = new PlaceContent({
						createdByGuid: Shark.$store.currUser.guid,
					});
					break;
				case "text":
					destView = textContentView;
					currContent = new TextContent({
						createdByGuid: Shark.$store.currUser.guid,
					});
					break;
			}

			Shark.set({
				currContent,
			});

			this.close();
			Shark.openPage(destView);
		}
	}
}

const newContentTypeModalComponent = new NewContentTypeModalComponent();

Shark.registerComponent(newContentTypeModalComponent);

export default newContentTypeModalComponent;
